const InsigitsIcon = ({ color = '#314158', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M14.6673 4.66797L9.00065 10.3346L5.66732 7.0013L1.33398 11.3346" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M10.666 4.66797H14.666V8.66797" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export default InsigitsIcon;

